import React, { FunctionComponent } from "react";

import { GridLayoutItem, GridLayoutItemProps } from "@multiweb/reactComponents";

export type GridLayoutMultiwebItemComponentProps = GridLayoutItemProps & {
    /** Určuje, zda je frame viditelný v multiwebu. */
    visible?: boolean;
};

/** Komponenta obalující klasický GridLayoutItem listenery pro použití v connectoru. */
export const GridLayoutMultiwebItemComponent: FunctionComponent<GridLayoutMultiwebItemComponentProps> = ({
    visible,
    children,
    ...gridLayoutItemProps
}) => {
    return (
        <GridLayoutItem {...gridLayoutItemProps} visible={visible}>
            {children}
        </GridLayoutItem>
    );
};
